import {combineReducers} from 'redux';
import drawer  from './drawer';
import pdf_viewer  from './pdf_viewer';

export default combineReducers({
    drawer,
    pdf_viewer
})


// WEBPACK FOOTER //
// ./src/reducers/shared/index.js